export default [
  [{sm_size: 12, md_size: 12, lg_size: 12}],
  [
    {sm_size: 12, md_size: 6, lg_size: 6},
    {sm_size: 12, md_size: 6, lg_size: 6}
  ],
  [
    {sm_size: 12, md_size: 12, lg_size: 4},
    {sm_size: 12, md_size: 12, lg_size: 4},
    {sm_size: 12, md_size: 12, lg_size: 4}
  ],
  [
    {sm_size: 12, md_size: 6, lg_size: 4},
    {sm_size: 12, md_size: 6, lg_size: 8}
  ],
  [
    {sm_size: 12, md_size: 6, lg_size: 3},
    {sm_size: 12, md_size: 6, lg_size: 3},
    {sm_size: 12, md_size: 6, lg_size: 3},
    {sm_size: 12, md_size: 6, lg_size: 3}
  ]
]
